<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- 订单详情 -->
    <template #ORDERDETAIL="{ params, visible }">
      <order
        v-if="visible"
        :orderDetails="params.dataDetails"
        :pageText="params.pageText"
        :footer-hide="false"
      ></order>
    </template>

    <!-- 订单轨迹 -->
    <template #ORDERTRACKER="{ params, visible }">
      <order-tracker :statusId="params.id" v-if="visible"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import {
  getOrderDetails,
  getOrder,
  getOrderStatus,
  getOrderType,
  postSheet,
  postPdf,
  returnPlan,
  getTimeType,
} from "@/api/order/list";
import {
  trackerObj1,
  orderTypeList,
  codList,
  interceptionList,
  OverseasdList,
  searchTypeObj,
  typeList,
  unpackList,
} from "@/view/order/order-template/localData.js";
import { getStatus } from "@/api/tracker/status";
import { getAllService } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
import { getList, exportFun, returnFun } from "@/api/ffc/ffcShipments";
import Tracker from "@/base/order_tracker";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import order from "_c/order-details";
import orderTracker from "@/base/order_tracker";
export default {
  name: "ffcShipments",
  components: {
    cTable,
    order,
    orderTracker,
  },
  data() {
    return {
      amount: 0,
      methods: {
        list: getList,
        getAllClient,
        exportFun,
        getOrderDetails,
        postSheet,
        postPdf,
        returnFun,
        // getDetails
      },
      config: {
        height: 630,
      },
      modals: {
        orderDetail: {
          contentSlot: "ORDERDETAIL",
          config: {
            listFn: "list",
            modalBind: {
              width: "80%",
            },
          },
          footer: {
            show: false,
          },
        },
        orderTracker: {
          contentSlot: "ORDERTRACKER",
          config: {
            listFn: "list",
            modalBind: {
              width: "30%",
            },
          },
          footer: {
            show: false,
          },
        },
        sheetList: {
          config: {
            modalBind: {
              width: 600,
            },
          },
          footer: {
            show: false,
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                name: () => "link",
                key: "link",
                align: "center",
                minWidth: 140,
              },
              {
                type: "btns",
                width: 250,
                name: () => "operation",
                fixed: "right",
                list: [
                  {
                    name: () => "print",
                    type: "show",
                    fnName: "showFun",
                    bind: {
                      type: "warning",
                    },
                  },
                ],
                methods: {
                  showFun({ row }) {
                    window.open(row.link, "_blank");
                  },
                },
              },
            ],
          },
        },
      },
      header: {
        config: {
          searchLength: 15,
          searchText: "search",
        },
        searchs: [
          {
            key: "time_type",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return "time type";
            },
            config: { label: "desc", value: "key" },
            methods: {
              async list({ field, searchForm }) {
                // field.options = await this.$sel.getData("NOON_SERVICE");
                field.options = (await getTimeType()).data.payload;
                searchForm["time_type"] = field.options[0]["key"];
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return "start time";
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return "end time";
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm["endTime"] = time;
                }
              },
            },
          },
          // {
          //   key: "type",
          //   component: "Select",
          //   bind: {
          //     style: "width:150px",
          //     multiple: true,
          //     "max-tag-count": 1,
          //   },
          //   placeholder() {
          //     return "order type";
          //   },
          //   options: [],
          // },
          {
            key: "serviceId",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return "Customer service name";
            },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getAllService()).data.payload;
                field.options = [].concat(res[1]).concat(res[2]).concat(res[3]);
                this.$forceUpdate();
              },
            },
          },
          {
            key: "statusCode",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return "track code";
            },
            config: { label: "tracker_code", value: "tracker_code" },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getStatus()).data.payload.rows;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "trackerCode",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return "Signing status";
            },
            options: trackerObj1,
          },
          {
            key: "from_country",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return "country of departure";
            },
            config: { label: "title", value: "code" },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getCountry({ allow_depart: 1 })).data.payload
                  .rows;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "countryCode",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return "Destination country";
            },
            config: { label: "title", value: "code" },
            methods: {
              async list({ field, searchForm }) {
                let res = (await getCountry({ allow_arrive: 1 })).data.payload
                  .rows;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          // {
          //   key: "codeStatus",
          //   component: "Select",
          //   bind: {
          //     style: "width:150px",
          //   },
          //   placeholder() {
          //     return "Current order status";
          //   },
          //   methods: {
          //     async list({ field, searchForm }) {
          //       field.options = await this.$sel.getData("ORDER_STATUS");
          //       this.$forceUpdate();
          //     },
          //   },
          // },
          {
            key: "codType",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return "payment type";
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                field.options = await this.$sel.getData("COD_TYPE");
                this.$forceUpdate();
              },
            },
          },
          {
            key: "is_cancel",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return "Pickup Cancel";
            },
            options: [
              { value: "YES", label: "YES" },
              { value: "NO", label: "NO" },
            ],
          },
          {
            key: "keywords",
            placeholder() {
              return "keywords";
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => "print",
              label: true,
              en: true,
            },
            {
              name: () => "export",
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            downFun({ field }) {
              let data = null;
              if (field.fun === "postSheet") {
                data = {
                  miniLabel: ["mini", "mini2"].includes(field.type)
                    ? true
                    : false,
                  ignoreInvoice: field.type == "mini2",
                  specialLable: field.type == "medium" ? true : false,
                  single: true,
                  orders: this.selectAll.map((item) => item.airway_number),
                };
              } else {
                data = {
                  type: "Invoice",
                  merge: true,
                  rule: "standard",
                  orderNo: this.selectAll.map((item) => item.airway_number),
                };
              }
              this.handleRequestMethods(field.fun, data).then((res) => {
                if (field.fun === "postSheet") {
                  if (res.payload.length > 1) {
                    this.getModal("sheetList").open(null, function () {
                      this.setTitle(this.$t("sheet"));
                      this.list = res.payload;
                    });
                  } else {
                    window.open(res.payload[0].link, "_blank");
                  }
                } else {
                  window.open(this.$globalUrl + res.data[0].url, "_blank");
                }
              });
            },
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          fixed: "left",
          align: "center",
          width: 60,
        },
        {
          name: () => "Order number",
          key: "airway_number",
          align: "center",
          fixed: "left",
          minWidth: 120,
          copy: true,
          width: 160,
          header: {
            copy: true, //头部复制
          },
          showOverflow: false,
          component: "Button",
          type: "toolbar",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              this.$page
                .handleRequestMethods("getOrderDetails", row.airway_number)
                .then((res) => {
                  this.$page.getModal("orderDetail").open(
                    {
                      dataDetails: res.payload,
                    },
                    function () {
                      this.setTitle(row.airway_number);
                    }
                  );
                });
            },
          },
        },
        {
          name: () => "order type",
          key: "type",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => "track code",
          key: "status",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => "Trajectory description",
          key: "status_remarks",
          align: "center",
          tooltip: true,
          minWidth: 110,
        },
        {
          name: () => "latest trajectory description",
          key: "status_time",
          align: "center",
          tooltip: true,
          minWidth: 100,
        },
        {
          name: () => "country of departure",
          key: "from_country",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "Destination country",
          key: "to_country",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "city name",
          key: "city_name",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "agent number",
          key: "agent_refer_code",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => "payment method",
          key: "cod_type",
          align: "center",
          tooltip: true,
          minWidth: 80,
        },
        {
          name: () => "Collection amount",
          key: "cod_amount",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "Declared value",
          key: "values",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "sender",
          key: "shipper_name",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "create time",
          key: "create_time",
          align: "center",
          tooltip: true,
          minWidth: 110,
        },
        {
          name: () => "Number of packages",
          key: "actual_weight",
          align: "center",
          tooltip: true,
          minWidth: 80,
        },
        {
          name: () => "weight",
          key: "Number of packages",
          align: "center",
          tooltip: true,
          minWidth: 80,
        },
        {
          name: () => "length" + "(CM)",
          key: "length",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "width" + "(CM)",
          key: "width",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "height" + "(CM)",
          key: "height",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "charge_volume",
          key: "charge_volume",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "Whether to cancel the pickup",
          key: "is_cancel",
          minWidth: 80,
        },
        {
          name: () => "recipient name",
          key: "consignee_contact",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "receiver's address",
          key: "consignee_address",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "recipient phone 1",
          key: "consignee_cellular",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => "recipient phone 2",
          key: "consignee_telephone",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => "product name",
          key: "goods_name",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "customs code",
          key: "goods_hs_code",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "commodity weight",
          key: "weight",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "commodity value",
          key: "goods_quantity",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "Number of Products",
          key: "goods_count",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "commodity code",
          key: "goods_title",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "remarks",
          key: "remarks",
          align: "center",
          minWidth: 80,
        },
        {
          name: () => "warehousing time",
          key: "inbound_time",
          align: "center",
          minWidth: 110,
        },
        {
          name: () => "Delivery time",
          key: "outbound_time",
          align: "center",
          minWidth: 110,
        },
        {
          name: () => "Customer service name",
          key: "serviceAccount",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => "Order Status",
          key: "code_status_txt",
          align: "center",
          minWidth: 110,
        },

        {
          type: "btns",
          width: 100,
          name: () => "operation",
          fixed: "right",
          list: [
            {
              name: () => "Track",
              type: "showStatus",
              fnName: "showStatus",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => "return to vnlin",
              type: "return",
              fnName: "returnFun",
              bind: {
                type: "warning",
              },
            },
          ],

          methods: {
            showStatus({ row }) {
              this.getModal("orderTracker").open(
                {
                  id: row.airway_number,
                },
                function () {
                  this.setTitle(row.airway_number);
                }
              );
            },
            returnFun({ row }) {
              this.$Modal.confirm({
                title: "return to vnlin",
                width: 300,
                content: "Do You Want To Do This?",
                onOk: () => {
                  this.handleRequestMethods(
                    "returnFun",
                    {
                      airway_number: row.airway_number,
                    },
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
